import React, { FC, memo } from 'react';
import { CourseCard } from 'src/common/components/CourseCard';
import { UserCoursesCard } from 'src/user/courses/components/UserCoursesCard';
import { UserCoursesCards } from 'src/user/courses/components/UserCoursesCards';
import { CourseExcerpt } from 'src/common/models/courseExcerpt';

export interface UserCoursesPastContentProps {
  items: CourseExcerpt[];
}

export const UserCoursesContinueLearningItems: FC<UserCoursesPastContentProps> = memo(
  ({ items }) => {
    return (
      <UserCoursesCards>
        {items.map((elearningExcerpt) => (
          <UserCoursesCard key={elearningExcerpt.id}>
            <CourseCard elearningProgressBar largeMobileImage courseExcerpt={elearningExcerpt} />
          </UserCoursesCard>
        ))}
      </UserCoursesCards>
    );
  },
);
UserCoursesContinueLearningItems.displayName = 'UserCoursesContinueLearningItems';
